'use strict';

class Information {
    constructor() {
        this.render();
    }

    render() {
        new More();
    }
}

class More {
    constructor() {
        this.initialCount = 15; // 初期表示件数
        this.render();
    }

    render() {
        var n = this.initialCount;
        var articleBox = $('.js-entries__body .js-entries__entry');
        var max = articleBox.length;

        if (max > n) {
            // 初期表示：15件以降を非表示
            articleBox.filter(':gt(' + (n - 1) + ')').hide();

            // ボタンを表示
            $('.inf_index_btn').show();

            $('body').on('click', '.js-entries__more', function () {
                // 全件表示
                articleBox.slideDown();
                $('.inf_index_btn').hide();
                return false;
            });
        } else {
            $('.inf_index_btn').hide();
        }
    }
}

export default Information;